// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-container {
  display: flex;
}

.title-justifyContent-center {
  justify-content: center;
}

.title-justifyContent-flex-end {
  justify-content: flex-end;
}

.title-justifyContent-flex-start {
  justify-content: flex-start;
}

.title {
  color: var(--midnight-blue-color);
  font-style: normal;
  font-weight: 600;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  -webkit-user-select: none;
          user-select: none;
}

.font-size-sm {
  font-size: 14px;
}

.font-size-md {
  font-size: 18px;
}

.font-size-lg {
  font-size: 24px;
}

.title-underline::after {
  content: "";
  position: absolute;
  width: 62px;
  height: 3px;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1A64AF;
}`, "",{"version":3,"sources":["webpack://./src/component/common/customTitle/CustomTitle.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;AAHF;;AAOI;EACI,uBAVS;AAMjB;;AAGI;EACI,yBAVS;AAUjB;;AADI;EACI,2BAVS;AAcjB;;AACA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAEF","sourcesContent":["$title-position: (\n  center, flex-end, flex-start\n);\n\n.title-container {\n  display: flex;\n}\n\n@each $key in $title-position{\n    .title-justifyContent-#{$key}{\n        justify-content: $key;\n    }\n}\n\n\n.title {\n  color: var(--midnight-blue-color);\n  font-style: normal;\n  font-weight: 600;\n  position: relative;\n  width: fit-content;\n  user-select: none;\n}\n\n.font-size-sm{\n  font-size: 14px;\n}\n\n.font-size-md{\n  font-size: 18px;\n}\n\n.font-size-lg{\n  font-size: 24px;\n}\n\n.title-underline::after {\n  content: \"\";\n  position: absolute;\n  width: 62px;\n  height: 3px;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #1A64AF;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
